import axios from 'axios'
import PocketBase from 'pocketbase';

export const pb = new PocketBase(import.meta.env.VITE_POCKETBASE_URL);

const postReqHeaders = ({
    headers: {
        'Content-Type': 'application/json'
    }
})

/**
 * Execute Netlify function in file: ./netlify/functions/parse-failed-transaction-email
 * @param obj
 * @returns response.data
 */
export const parseFailedTransactionEmail = async (obj: any) => {
    try {
        const requestUrl = "/.netlify/functions/parse-failed-transaction-email"
        const result: any = await axios.post(requestUrl, obj, postReqHeaders)
        const response = result.data
        return response
    } catch (error: any) {
        console.error(`ERROR in parseFailedTransactionEmail `, { obj, error }, error.toString())
    }
}

/**
 * Execute Netlify function in file: ./netlify/functions/prepare-agreement
 * @param obj
 * @returns response.data
 */
export const prepareAgreement = async (obj: any) => {
    try {
        const requestUrl = "/.netlify/functions/prepare-agreement"
        const result: any = await axios.post(requestUrl, obj, postReqHeaders)
        const response = result.data;
        return response;
    } catch (error: any) {
        console.error(`ERROR in prepareAgreement `, { obj, error }, error.toString())
    }
}

/**
 * Prepare lease addendum agreement for existing customers
 * Execute Netlify function in file: ./netlify/functions/prepare-addendum-agreement
 * @param obj - EioLeaseAddendumPayload object
 * @returns response.data
 */
export const prepareAddendumAgreement = async (obj: any) => {
    try {
        const requestUrl = "/.netlify/functions/prepare-addendum-agreement"
        const result: any = await axios.post(requestUrl, obj, postReqHeaders)
        const response = result.data;
        return response;
    } catch (error: any) {
        console.error(`ERROR in prepareAddendumAgreement `, { obj, error }, error.toString())
        throw error
    }
}

/**
 * Execute Netlify function in file: ./netlify/functions/handle-signed-agreement
 * @param obj
 * @returns response.data
 */
export const handleSignedAgreement = async (contractId: string) => {
    try {
        const requestUrl = "/.netlify/functions/handle-signed-agreement"
        const result: any = await axios.post(requestUrl, { contractId }, postReqHeaders)
        const response = result.data
        return response
    } catch (error: any) {
        console.error(`ERROR in handleSignedAgreement `, { contractId, error }, error.toString())
    }
}

/**
 * Execute Netlify function in file: ./netlify/functions/prepare-payment
 * @param obj
 * @returns response.data
 */
export const preparePayment = async (obj: any) => {
    try {
        const requestUrl = "/.netlify/functions/prepare-payment"
        const result: any = await axios.post(requestUrl, obj, postReqHeaders)
        return result
    } catch (error: any) {
        console.error(`ERROR in preparePayment `, { obj, error }, error.toString())
    }
}

/**
 * Start a self-service payment-method update for the logged-in customer.
 * Execute Netlify function in file: ./netlify/functions/prepare-payment-method-update
 * @param token - Customer's OTP session token (pb.authStore.token)
 * @returns response.data with checkoutToken
 */
export const preparePaymentMethodUpdate = async (token: string) => {
    const requestUrl = "/.netlify/functions/prepare-payment-method-update"
    const result: any = await axios.post(requestUrl, { token, agreedToDefault: true }, postReqHeaders)
    return result.data
}

/**
 * Record a completed self-service payment-method update to the events log.
 * Execute Netlify function in file: ./netlify/functions/record-payment-method-update
 * @param token - Customer's OTP session token (pb.authStore.token)
 */
export const recordPaymentMethodUpdate = async (
    token: string,
    cardLast4: string,
    paymentMethodType: 'cc' | 'ach'
) => {
    const requestUrl = "/.netlify/functions/record-payment-method-update"
    const result: any = await axios.post(requestUrl, { token, cardLast4, paymentMethodType }, postReqHeaders)
    return result.data
}

/**
 * Log a failed self-service payment-method update attempt (card declined, etc).
 * Execute Netlify function in file: ./netlify/functions/record-payment-method-failure
 * @param token - Customer's OTP session token (pb.authStore.token)
 * @param reason - Human-readable failure reason (e.g. Helcim's decline message)
 */
export const recordPaymentMethodFailure = async (token: string, reason: string) => {
    const requestUrl = "/.netlify/functions/record-payment-method-failure"
    const result: any = await axios.post(requestUrl, { token, reason }, postReqHeaders)
    return result.data
}

/**
 * Execute Netlify function in file: ./netlify/functions/send-existing-customer-otp
 * @param email - Customer email address
 * @returns response.data
 */
export const sendExistingCustomerOTP = async (email: string) => {
    try {
        const requestUrl = "/.netlify/functions/send-existing-customer-otp"
        const result: any = await axios.post(requestUrl, { email }, postReqHeaders)
        const response = result.data
        return response
    } catch (error: any) {
        console.error(`ERROR in sendExistingCustomerOTP `, { email, error }, error.toString())
        throw error
    }
}

/**
 * Execute Netlify function in file: ./netlify/functions/verify-customer-otp
 * @param email - Customer email address
 * @param otpCode - OTP code received via email
 * @param otpId - OTP ID returned from sendExistingCustomerOTP
 * @returns response.data with auth token and user info
 */
export const verifyCustomerOTP = async (email: string, otpCode: string, otpId: string) => {
    try {
        const requestUrl = "/.netlify/functions/verify-customer-otp"
        const result: any = await axios.post(requestUrl, { email, otpCode, otpId }, postReqHeaders)
        const response = result.data
        return response
    } catch (error: any) {
        console.error(`ERROR in verifyCustomerOTP `, { email, error }, error.toString())
        throw error
    }
}

/**
 * Verify an OTP for the resume/recovery flow — tolerates incomplete customers.
 * Execute Netlify function in file: ./netlify/functions/verify-customer-otp-resume
 */
export const verifyCustomerOtpResume = async (otpId: string, otpCode: string) => {
    const requestUrl = '/.netlify/functions/verify-customer-otp-resume'
    const result: any = await axios.post(requestUrl, { otpId, otpCode }, postReqHeaders)
    return result.data
}

/**
 * Create a new incomplete customer and send OTP for email verification
 * Execute Netlify function in file: ./netlify/functions/send-new-customer-otp
 */
export const sendNewCustomerOTP = async (data: { first_name: string, last_name: string, email: string, phone: string }) => {
    try {
        const requestUrl = "/.netlify/functions/send-new-customer-otp"
        const result: any = await axios.post(requestUrl, data, postReqHeaders)
        return result.data
    } catch (error: any) {
        console.error(`ERROR in sendNewCustomerOTP`, { data, error }, error.toString())
        throw error
    }
}

/**
 * Verify OTP for a new customer during reservation flow
 * Execute Netlify function in file: ./netlify/functions/verify-new-customer-otp
 */
export const verifyNewCustomerOTP = async (otpId: string, otpCode: string, customerId: string) => {
    try {
        const requestUrl = "/.netlify/functions/verify-new-customer-otp"
        const result: any = await axios.post(requestUrl, { otpId, otpCode, customerId }, postReqHeaders)
        return result.data
    } catch (error: any) {
        console.error(`ERROR in verifyNewCustomerOTP`, { error }, error.toString())
        throw error
    }
}

/**
 * Fetch all available (vacant) storage spaces
 * Execute Netlify function in file: ./netlify/functions/list-available-spaces
 * @returns response.data with array of spaces
 */
export const listAvailableSpaces = async () => {
    try {
        const requestUrl = "/.netlify/functions/list-available-spaces"
        const result: any = await axios.get(requestUrl)
        const response = result.data
        return response
    } catch (error: any) {
        console.error(`ERROR in listAvailableSpaces `, { error }, error.toString())
        throw error
    }
}

/**
 * Get details for a specific space by ID
 * Execute Netlify function in file: ./netlify/functions/get-space-details
 * @param spaceId - The ID of the space to fetch
 * @returns response.data with space details
 */
export const getSpaceDetails = async (spaceId: string) => {
    try {
        const requestUrl = "/.netlify/functions/get-space-details"
        const result: any = await axios.post(requestUrl, { spaceId }, postReqHeaders)
        const response = result.data
        return response
    } catch (error: any) {
        console.error(`ERROR in getSpaceDetails `, { spaceId, error }, error.toString())
        throw error
    }
}

/**
 * Get lease details by contract reference ID
 * Execute Netlify function in file: ./netlify/functions/get-lease-by-contract-id
 * @param contractId - The eSignatures.io contract ID
 * @returns response.data with lease details (expanded with customer and vehicles)
 */
export const getLeaseByContractId = async (contractId: string) => {
    try {
        const requestUrl = "/.netlify/functions/get-lease-by-contract-id"
        const result: any = await axios.post(requestUrl, { contractId }, postReqHeaders)
        const response = result.data
        return response
    } catch (error: any) {
        console.error(`ERROR in getLeaseByContractId `, { contractId, error }, error.toString())
        throw error
    }
}

// Helper function to convert File to base64 string
const fileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result as string)
        reader.onerror = error => reject(error)
    })
}

// Uploads are sent as base64 inside the create-reservation JSON body. Netlify's
// synchronous functions cap the whole request at ~6 MB, and phone photos (3–5 MB
// each, ×1.37 for base64) blow past that and crash the function (this is exactly
// what stranded a customer: repeated "Internal Error" at submit). So we downscale
// + re-encode images client-side before upload, then hard-guard the total size.
const MAX_UPLOAD_PAYLOAD_BYTES = 4_500_000 // headroom under Netlify's ~6 MB request cap

const loadImage = (src: string): Promise<HTMLImageElement> =>
    new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => resolve(img)
        img.onerror = reject
        img.src = src
    })

// Downscale to maxDim on the longest edge and re-encode as JPEG. Non-images
// (e.g. PDFs) pass through untouched — we can't canvas-compress them. Never
// returns something larger than the original.
export const compressImageFile = async (
    file: File,
    { maxDim = 1600, quality = 0.7 }: { maxDim?: number; quality?: number } = {},
): Promise<File> => {
    if (!file.type?.startsWith('image/')) return file
    try {
        const img = await loadImage(await fileToBase64(file))
        let { width, height } = img
        const longest = Math.max(width, height)
        if (longest > maxDim) {
            const scale = maxDim / longest
            width = Math.round(width * scale)
            height = Math.round(height * scale)
        }
        const canvas = document.createElement('canvas')
        canvas.width = width
        canvas.height = height
        const ctx = canvas.getContext('2d')
        if (!ctx) return file
        ctx.drawImage(img, 0, 0, width, height)
        const blob = await new Promise<Blob | null>(res => canvas.toBlob(res, 'image/jpeg', quality))
        if (!blob || blob.size >= file.size) return file // don't inflate small/optimized files
        const name = file.name.replace(/\.[^.]+$/, '') + '.jpg'
        return new File([blob], name, { type: 'image/jpeg' })
    } catch {
        // If compression fails for any reason, fall back to the original file;
        // the size guard below still protects the request.
        return file
    }
}

// Compress (if image) then base64-encode a File into the {name,type,base64}
// shape the create-* functions send.
const encodeFileField = async (file: File): Promise<{ name: string; type: string; base64: string }> => {
    const compressed = await compressImageFile(file)
    return { name: compressed.name, type: compressed.type, base64: await fileToBase64(compressed) }
}

// Fail fast with a human message before we ever POST an oversized body (which
// would otherwise crash the function and surface as a useless "Internal Error").
const assertUploadsWithinLimit = (encoded: Array<{ base64?: string } | undefined | null>): void => {
    const totalBytes = encoded.reduce((sum, f) => {
        if (!f?.base64) return sum
        const b64 = f.base64.includes(',') ? f.base64.split(',')[1] : f.base64
        return sum + Math.ceil((b64.length * 3) / 4)
    }, 0)
    if (totalBytes > MAX_UPLOAD_PAYLOAD_BYTES) {
        const mb = (totalBytes / 1_000_000).toFixed(1)
        const err: any = new Error(
            `Your uploaded photos total about ${mb} MB, which is too large to submit. ` +
            `Please retake or choose smaller photos (a normal phone photo is fine) and try again. ` +
            `If it keeps happening, call us at (614) 699-2495 and we'll finish setting you up.`,
        )
        err.isUploadSizeError = true
        throw err
    }
}

/**
 * Regenerate the lease agreement for an existing (e.g. rescued) customer from
 * their DB records — no re-typing. Used by the /complete self-service flow.
 * Execute Netlify function: ./netlify/functions/prepare-completion-agreement
 * @param data - the customer's OTP token + the redirect URL to return to after signing
 * @returns { success, contract_id, sign_page_url, lease_id, space_id }
 */
export const prepareCompletionAgreement = async (data: { token: string; redirect_url: string }) => {
    const result: any = await axios.post('/.netlify/functions/prepare-completion-agreement', data, postReqHeaders)
    return result.data
}

/**
 * Create a full reservation (customer + vehicle + lease)
 * Execute Netlify function in file: ./netlify/functions/create-reservation
 * @param data - Object containing customer, vehicle, and lease data
 * @returns response.data with created customer, vehicle, and lease records
 */
export const createReservation = async (data: {
    customer: {
        username: string
        email: string
        password: string
        passwordConfirm: string
        first_name: string
        last_name: string
        phone: string
        business_name?: string
        address_line_1: string
        address_line_2?: string
        city: string
        state: string
        zip: string
        emergency_contact_name: string
        emergency_contact_phone: string
        driver_lic_front?: any
        driver_lic_back?: any
    }
    vehicle: {
        type: string
        year: string
        make: string
        model: string
        lic_plate_state: string
        lic_plate_number: string
        vin: string
        description?: string
        proof_of_insurance?: any
    }
    lease: {
        spaceId: string
        move_in_date?: Date | string
        move_out_date?: Date | string
        options?: string[]
        contract_ref_id: string
    }
    customerAuthToken?: string
}) => {
    try {
        const requestUrl = "/.netlify/functions/create-reservation"

        // Convert File objects to base64 strings for JSON serialization
        const processedData = {
            customer: { ...data.customer },
            vehicle: { ...data.vehicle },
            lease: { ...data.lease }
        }

        if (data.customerAuthToken) {
            (processedData as any).customerAuthToken = data.customerAuthToken
        }

        // Compress + base64-encode uploads (guards against the ~6 MB Netlify crash)
        if (data.customer.driver_lic_front instanceof File) {
            processedData.customer.driver_lic_front = await encodeFileField(data.customer.driver_lic_front)
        }
        if (data.customer.driver_lic_back instanceof File) {
            processedData.customer.driver_lic_back = await encodeFileField(data.customer.driver_lic_back)
        }
        if (data.vehicle.proof_of_insurance instanceof File) {
            processedData.vehicle.proof_of_insurance = await encodeFileField(data.vehicle.proof_of_insurance)
        }

        assertUploadsWithinLimit([
            processedData.customer.driver_lic_front,
            processedData.customer.driver_lic_back,
            processedData.vehicle.proof_of_insurance,
        ])

        const result: any = await axios.post(requestUrl, processedData, postReqHeaders)
        const response = result.data
        return response
    } catch (error: any) {
        if (error?.response?.status === 409 && error.response.data) {
            return error.response.data
        }
        console.error(`ERROR in createReservation `, { error }, error.toString())
        throw error
    }
}

/**
 * Attach a proof-of-insurance document to the authenticated customer's vehicle.
 * The vehicles collection is admin-only, so this goes through a function that
 * verifies the customer's OTP token and writes as an api_client. Image is
 * compressed client-side first (same as the reservation path).
 * Execute Netlify function in file: ./netlify/functions/update-vehicle-document
 */
export const updateVehicleDocument = async (data: { token: string; proof_of_insurance: File }) => {
    const field = await encodeFileField(data.proof_of_insurance)
    assertUploadsWithinLimit([field])
    const result: any = await axios.post(
        '/.netlify/functions/update-vehicle-document',
        { token: data.token, proof_of_insurance: field },
        postReqHeaders,
    )
    return result.data
}

/**
 * Update the authenticated customer's own profile (address, emergency contact,
 * driver's licence photos). The customers collection is api_clients-write-only
 * by rule (a customer can read but NOT update their own record — a direct
 * pb.update 404s), so this routes through a function that writes as an
 * api_client. Licence images are compressed client-side first.
 * Execute Netlify function in file: ./netlify/functions/update-customer-profile
 */
export const updateCustomerProfile = async (data: {
    token: string
    address_line_1?: string
    address_line_2?: string
    city?: string
    state?: string
    zip?: string
    emergency_contact_name?: string
    emergency_contact_phone?: string
    driver_lic_front?: File
    driver_lic_back?: File
}) => {
    const payload: any = { token: data.token }
    for (const f of ['address_line_1', 'address_line_2', 'city', 'state', 'zip', 'emergency_contact_name', 'emergency_contact_phone'] as const) {
        if (data[f]) payload[f] = data[f]
    }
    const encoded: Array<{ base64?: string }> = []
    if (data.driver_lic_front instanceof File) { payload.driver_lic_front = await encodeFileField(data.driver_lic_front); encoded.push(payload.driver_lic_front) }
    if (data.driver_lic_back instanceof File) { payload.driver_lic_back = await encodeFileField(data.driver_lic_back); encoded.push(payload.driver_lic_back) }
    assertUploadsWithinLimit(encoded)
    const result: any = await axios.post('/.netlify/functions/update-customer-profile', payload, postReqHeaders)
    return result.data
}

/**
 * Create lease addendum for existing customers (additional vehicle/space)
 * Execute Netlify function in file: ./netlify/functions/create-lease-addendum
 * @param data - Object containing customerId, vehicle, and lease data
 * @returns response.data with created vehicle and addendum lease records
 */
export const createLeaseAddendum = async (data: {
    customerId: string
    vehicle: {
        type: string
        year: string
        make: string
        model: string
        lic_plate_state: string
        lic_plate_number: string
        vin: string
        description?: string
        proof_of_insurance?: any
    }
    lease: {
        spaceId: string
        move_in_date?: Date | string
        move_out_date?: Date | string
        options?: string[]
        contract_ref_id: string
    }
}) => {
    try {
        const requestUrl = "/.netlify/functions/create-lease-addendum"

        // Convert File objects to base64 strings for JSON serialization
        const processedData: any = {
            customerId: data.customerId,
            vehicle: { ...data.vehicle },
            lease: { ...data.lease }
        }

        // Compress + base64-encode the upload (guards against the ~6 MB Netlify crash)
        if (data.vehicle.proof_of_insurance instanceof File) {
            processedData.vehicle.proof_of_insurance = await encodeFileField(data.vehicle.proof_of_insurance)
        }

        assertUploadsWithinLimit([processedData.vehicle.proof_of_insurance])

        const result: any = await axios.post(requestUrl, processedData, postReqHeaders)
        const response = result.data
        return response
    } catch (error: any) {
        console.error(`ERROR in createLeaseAddendum `, { error }, error.toString())
        throw error
    }
}

/**
 * Update lease with signed PDF after eSignature
 * Execute Netlify function in file: ./netlify/functions/update-signed-lease
 * @param contractId - eSignatures.io contract ID
 * @param signedPdfUrl - URL to signed PDF
 * @param signedDate - ISO timestamp of signature
 * @returns response.data with updated lease
 */
export const updateSignedLease = async (contractId: string, signedPdfUrl: string, signedDate: string) => {
    try {
        const requestUrl = "/.netlify/functions/update-signed-lease"
        const result: any = await axios.post(requestUrl, {
            contractId,
            signedPdfUrl,
            signedDate
        }, postReqHeaders)
        const response = result.data
        return response
    } catch (error: any) {
        console.error(`ERROR in updateSignedLease `, { contractId, error }, error.toString())
        throw error
    }
}

/**
 * Complete payment flow - activate lease after successful payment
 * Execute Netlify function in file: ./netlify/functions/complete-payment
 * @param paymentData - Payment completion data
 * @returns response.data with updated lease, customer, space, payment, and deposit records
 */
export const completePayment = async (paymentData: {
    contractId: string
    customerId: string
    transactionId: string
    invoiceNumber?: string
    paymentMethod: string
    amount?: number
    dueDate?: string
}) => {
    try {
        const requestUrl = "/.netlify/functions/complete-payment"
        const result: any = await axios.post(requestUrl, paymentData, postReqHeaders)
        const response = result.data
        return response
    } catch (error: any) {
        console.error(`ERROR in completePayment `, { paymentData, error }, error.toString())
        throw error
    }
}

/**
 * Fetch the active primary lease for a customer
 * Execute Netlify function in file: ./netlify/functions/get-customer-lease
 */
export const getCustomerLease = async (customerId: string) => {
    try {
        const requestUrl = '/.netlify/functions/get-customer-lease'
        const result: any = await axios.post(requestUrl, { customerId }, postReqHeaders)
        return result.data
    } catch (error: any) {
        console.error('ERROR in getCustomerLease', { customerId, error }, error.toString())
        throw error
    }
}

/**
 * Fetch a single lease by its PocketBase record id
 * Execute Netlify function in file: ./netlify/functions/get-lease-by-id
 */
export const getLeaseById = async (leaseId: string) => {
    try {
        const requestUrl = '/.netlify/functions/get-lease-by-id'
        const result: any = await axios.post(requestUrl, { leaseId }, postReqHeaders)
        return result.data
    } catch (error: any) {
        console.error('ERROR in getLeaseById', { leaseId, error }, error.toString())
        throw error
    }
}

/**
 * Create vehicles + lease record and initiate eSign contract for lease generation (no payment)
 * Execute Netlify function in file: ./netlify/functions/prepare-lease-generation
 */
export const prepareLeasGeneration = async (data: {
    customerId: string
    vehicles: Array<{
        type: string
        year: string
        make: string
        model: string
        lic_plate_state: string
        lic_plate_number: string
        vin: string
        description?: string
        proof_of_insurance: File
        space_identifier?: string
    }>
    driver_lic_front?: File
    driver_lic_back?: File
    move_in_date: string
    redirect_url: string
}) => {
    try {
        const requestUrl = '/.netlify/functions/prepare-lease-generation'

        const processedData: any = {
            customerId: data.customerId,
            move_in_date: data.move_in_date,
            redirect_url: data.redirect_url,
            vehicles: [],
        }

        // Convert each vehicle's proof_of_insurance to base64
        for (const v of data.vehicles) {
            const processedVehicle: any = {
                type: v.type,
                year: v.year,
                make: v.make,
                model: v.model,
                lic_plate_state: v.lic_plate_state,
                lic_plate_number: v.lic_plate_number,
                vin: v.vin,
                description: v.description,
                space_identifier: v.space_identifier,
            }
            // Compress + base64-encode the upload (guards against the ~6 MB Netlify crash)
            if (v.proof_of_insurance instanceof File) {
                processedVehicle.proof_of_insurance = await encodeFileField(v.proof_of_insurance)
            }
            processedData.vehicles.push(processedVehicle)
        }

        // Compress + base64-encode driver's license files
        if (data.driver_lic_front instanceof File) {
            processedData.driver_lic_front = await encodeFileField(data.driver_lic_front)
        }
        if (data.driver_lic_back instanceof File) {
            processedData.driver_lic_back = await encodeFileField(data.driver_lic_back)
        }

        assertUploadsWithinLimit([
            ...processedData.vehicles.map((pv: any) => pv.proof_of_insurance),
            processedData.driver_lic_front,
            processedData.driver_lic_back,
        ])

        const result: any = await axios.post(requestUrl, processedData, postReqHeaders)
        return result.data
    } catch (error: any) {
        console.error('ERROR in prepareLeasGeneration', { error }, error.toString())
        throw error
    }
}

/**
 * Log an error or event to PocketBase via the log-error Netlify function.
 * Fire-and-forget — never throws.
 */
export const logErrorToDb = async (data: {
    event_name: string
    error_message: string
    error_details?: any
    customer_email?: string
    form_step?: number
    payload_snapshot?: any
}) => {
    try {
        await axios.post('/.netlify/functions/log-error', {
            ...data,
            user_agent: navigator.userAgent,
            app_version: __APP_VERSION__,
        }, { headers: { 'Content-Type': 'application/json' } })
    } catch (e) {
        // Silent — logging should never break the app
        console.error('Failed to log error to DB:', e)
    }
}

export const extractNestedMessage = (payload: any): string | null => {

    const error = JSON.parse(JSON.stringify(payload, null, 2))

    // Check if data exists
    if (!error?.originalError?.response?.data) {
        return null;
    }

    const errorData = error.originalError.response.data
    // Get the first key under data (email, phone, etc.)
    const keys = Object.keys(errorData);

    if (keys.length === 0) {
        return null;
    }

    // Access the nested object using the first key and get the message
    const nestedObject = errorData[keys[0]];

    return nestedObject?.message ? `"${keys[0]}": ${nestedObject.message}` : null;
}